import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SmallChartDownloadedAcknowledgedConfig } from '@app/constants/constants';
import { MFDType } from '@app/constants/enum';

@Component({
  selector: 'app-small-chart-downloaded-acknowledged',
  templateUrl: './small-chart-downloaded-acknowledged.component.html',
  styleUrls: ['./small-chart-downloaded-acknowledged.component.scss']
})
export class SmallChartDownloadedAcknowledgedComponent implements OnInit {
  isNewChart: boolean;
  mfdType: number;
  mfdTypeEnum = MFDType
  config = SmallChartDownloadedAcknowledgedConfig;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.isNewChart = this.data.isNewChart
    this.mfdType = this.data.mfdType
  }

}
